import { useLazyQuery } from '@apollo/client';
import { ResultHistoriesQuery } from 'src/graphql/resultHistory/query';

export default ({ entityId, entityClass }) => {
  const [callback, { error, ...rest }] = useLazyQuery(ResultHistoriesQuery, { 
    variables: { entityId, entityClass }, 
    notifyOnNetworkStatusChange: true, 
    fetchPolicy: 'cache-and-network' 
  });

  return [callback, { error, ...rest }];
};
